// React Imports
import React, { useState } from 'react';

import Card from '../../Card/card';
import CardHeader from '../../Card/cardHeader';
import CardFooter from '../../Card/cardFooter';
import InfoIcon from '@material-ui/icons/Info';
import CardBody from '../../Card/cardBody';
import CenteredCircularProgress from '../../Common/CenteredCircularProgress';

import withStyles from '@material-ui/core/styles/withStyles';
import { grayColor, whiteColor } from '../../../style/style';
import { IconButton, Tooltip } from '@material-ui/core';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { Rnd } from 'react-rnd';
import DeleteIcon from '@mui/icons-material/Delete';

const styles = (theme) => ({
  card: {
    height: "100%",
    width: "100%",
    userSelect: "none"
  },
  stats: {
    color: grayColor[0],
    display: 'inline-flex',
    fontSize: '12px',
    lineHeight: '22px',
    '& svg': {
      top: '4px',
      width: '16px',
      height: '16px',
      position: 'relative',
      marginRight: '3px',
      marginLeft: '3px',
    },
    '& .fab,& .fas,& .far,& .fal,& .material-icons': {
      top: '4px',
      fontSize: '16px',
      position: 'relative',
      marginRight: '3px',
      marginLeft: '3px',
    },
  },
  cardTitle: {
    // color: whiteColor,
    marginTop: '0px',
    minHeight: 'auto',
    fontWeight: '530',
    fontSize: '15px',
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: '3px',
    textDecoration: 'none',
    textTransform: 'uppercase',
    '& small': {
      color: grayColor[1],
      fontWeight: '400',
      lineHeight: '1',
    },
  },
  cardBody: {},
  center: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
  },
  tooltip: {
    marginLeft: 10,
    cursor: 'pointer'
  },
  flex: {
    display: "flex",
    justifyContent: 'space-between', // Aligns items to each end of the container
    alignItems: "center"
  }
});

const WidgetCommon = (props) => {
  const { classes, title, children, footer, isLoading, hasNoData, hasTooMuchData, tooMuchDataString, handleRemove, hideIfNoData, info, graphSwitch, setGraphType, graphType, allowResize, allowEdits, size, position, handleWidgetChange, widgetId, gridStep  } = props;

  const errorContent = () => {
    let text = "";
    if (hasNoData) {
      text = "No Data";
    } else if (hasTooMuchData) {
      text = tooMuchDataString;
    }

    return (<div className={classes.center}>
      <p>{text}</p>
    </div>);
  };

  const handleChange = (event) => {
    setGraphType(event.target.value);
  }

  const handleSizeChange = (edit, direction, ref, delta, newPosition) => {
    handleWidgetChange({
      id: widgetId,
      position: {
        x: Math.floor(Math.abs(newPosition.x) / gridStep),
        y: Math.floor(Math.abs(newPosition.y) / gridStep)
      },
      size: {
        width: Math.floor(Math.abs(parseInt(ref.style.width, 10)) / gridStep),
        height: Math.floor(Math.abs(parseInt(ref.style.height, 10)) / gridStep)
      }
    });
  }

  const handlePositionChange = (event, newPosition) => {
    handleWidgetChange({
      id: widgetId,
      position: {
        x: Math.floor(Math.abs(newPosition.x) / gridStep),
        y: Math.floor(Math.abs(newPosition.y) / gridStep)
      },
      size
    });
  }

  return (
    <Rnd
      bounds="#widget-container"
      dragGrid={[gridStep, gridStep]}
      resizeGrid={[gridStep, gridStep]}
      minHeight={gridStep * 2}
      minWidth={gridStep * 2}
      size={{
        height: size.height * gridStep,
        width: size.width * gridStep
      }}
      position={{
        x: position.x * gridStep,
        y: position.y * gridStep
      }}
      onDragStop={handlePositionChange}
      onResizeStop={handleSizeChange}
      disableDragging={!allowEdits}
      enableResizing={allowResize && allowEdits && {
        bottom: true,
        bottomLeft: false,
        bottomRight: true,
        left: false,
        right: true,
        top: false,
        topLeft: false,
        topRight: false
      }}
      style={{
        padding: 5
      }}
    >
      <Card className={classes.card} style={hideIfNoData && hasNoData ? { display: "none" } : {}}>
        <CardHeader>
          <div className={classes.flex}>
            <h4 className={classes.cardTitle} style={{ color: 'black' }}>
              {title}
            </h4>
            {
              graphSwitch ?
                <ToggleButtonGroup
                  color="primary"
                  value={graphType}
                  exclusive
                  onChange={handleChange}
                  aria-label="Graph Type"
                  size="small"
                >
                  <ToggleButton value="linear">Linear</ToggleButton>
                  <ToggleButton value="symlog">Log</ToggleButton>
                </ToggleButtonGroup>
                : null
            }
            {
              allowEdits && (
                <IconButton onClick={() => handleRemove(widgetId)}>
                  <DeleteIcon/>
                </IconButton>
              )
            }
          </div>
        </CardHeader>
        <CardBody className={classes.cardBody}>
          {isLoading ?
            <div className={classes.center}>
              <CenteredCircularProgress size={100} />
            </div> :
            hasNoData || hasTooMuchData ? errorContent() :
            <div className={classes.center}>
              {children}
            </div>}
        </CardBody>
        <CardFooter stats>
          <div className={classes.stats}>
            {footer}
          </div>
          {
            info && (
              <Tooltip
                title={info}
                className={classes.tooltip}
                color="primary"
              >
                <InfoIcon />
              </Tooltip>
            )
          }
        </CardFooter>
      </Card>
    </Rnd>
  );
};

export default withStyles(styles)(WidgetCommon);


